import { z } from 'zod';

export const DeclarantUsersItemSchema = z.object({
  _id: z.string().or(z.any()),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().email(),
  visible: z.boolean().optional(),
});

export type DeclarantUsersItem = z.infer<typeof DeclarantUsersItemSchema>;

export const GetDeclarantUsersResultSchema = z.object({
  data: z.array(DeclarantUsersItemSchema),
});

export type GetDeclarantUsersResult = z.infer<typeof GetDeclarantUsersResultSchema>;

export const GetDeclarantUsersSchema = z.object({
  declarantId: z.string(),
});

export type GetDeclarantUsers = z.infer<typeof GetDeclarantUsersSchema>;
